import React from 'react'
import AssetsContainer from '../containers/AssetsContainer'

const AssetsPage = () => ( 
  <>    
    <div id="main-container" className="container mt-5">
        <AssetsContainer />
    </div>
  </>
)

export default AssetsPage